import axios from 'axios';
import { defaultTo } from 'ramda';

import { postFiles } from '../util/axios';

export const apiGetCEUs = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/individual-ceus`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiAllCEUs = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/admin/individual-ceus`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiAddCEU = (payload) => postFiles('/api/individual-ceu', payload);
export const apiGetCEU = (id) => axios.get(`/api/individual-ceu/${id}`);
export const apiAddFile = (id, payload) => postFiles(`/api/individual-ceu/${id}/file`, payload);
export const apiUpdateCEU = ({ id, ...payload }) => axios.patch(`/api/individual-ceu/${id}`, payload);
export const apiDeleteCEU = (id) => axios.delete(`/api/individual-ceu/${id}`);
export const apiApproveCEU = (id, payload) => axios.post(`/api/admin/individual-ceu/${id}/approve`, payload);
export const apiRejectCEU = (id, payload) => axios.post(`/api/admin/individual-ceu/${id}/reject`, payload);

export const apiGetCEUsFromReportingPeriod = ({ reportingPeriodId }) =>
  axios.get(`/api/ceus/${defaultTo('', reportingPeriodId)}`);
export const apiAdminGetCEUsFromReportingPeriod = ({ userId, reportingPeriodId }) =>
  axios.get(`/api/admin/user/${userId}/ceus/${defaultTo('', reportingPeriodId)}`);

// Group CEUs
export const apiGetGroupCEUs = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/group-ceus`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiAllGroupCEUs = ({ pageSize, page, sorted, filtered }) => {
  const sort = sorted.map((column) => `${column.id},${column.desc ? 'desc' : 'asc'}`);
  const filter = filtered.map((column) => `${column.id},${column.value}`);
  return axios.get(`/api/admin/group-ceus`, { params: { limit: pageSize, page, sort, filter }, skipLoader: true });
};
export const apiAddGroupCEU = ({ token, ...payload }) =>
  postFiles('/api/group-ceu', { ...payload, stripeToken: token });
export const apiGetGroupCEU = (id) => axios.get(`/api/group-ceu/${id}`);
export const apiAddGroupFile = (id, payload) => postFiles(`/api/group-ceu/${id}/file`, payload);
export const apiUpdateGroupCEU = ({ id, ...payload }) => axios.patch(`/api/group-ceu/${id}`, payload);
export const apiDeleteGroupCEU = (id) => axios.delete(`/api/group-ceu/${id}`);
export const apiApproveGroupCEU = (id, payload) => axios.post(`/api/admin/group-ceu/${id}/approve`, payload);
export const apiRejectGroupCEU = (id, payload) => axios.post(`/api/admin/group-ceu/${id}/reject`, payload);
export const apiSearchCEUCode = (code) => axios.get(`/api/completion-code?q=${code}`);
